import "ios-vibrator-pro-max";
import { current } from "../helpers/current_helpers"

export const vibrate = (pattern) => {
  if (current.appEnvironment !== "production") {
    console.log("vibrate", pattern)
  }

  if ('vibrate' in navigator) {
    navigator.vibrate(pattern)
  }
}
